import set from 'lodash/set';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useEffectOnce } from 'react-use';

const AdvSlider = ({ min, max, value, onChange, className, id }) => {
  const debounceRef = useRef(null);

  useEffectOnce(() => {
    if (!debounceRef.current) {
      debounceRef.current = debounce(onChange, 100);
    }
  });

  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <input
      type="range"
      min={min}
      max={max}
      value={currentValue}
      className={`adv-slider ${className}`}
      id={id}
      onChange={event => {
        event.persist();
        setCurrentValue(event.target.value);
        debounceRef.current(event.target.value);
      }}
    />
  );
};

AdvSlider.defaultProps = {
  id: null,
  className: '',
  onChange: () => {},
};

AdvSlider.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

export const advSliderChanged = (clientId, storeFormData, path) => v => {
  storeFormData(set({}, path, v), clientId);
};

export default AdvSlider;
